import ApiService from "@/core/services/api.service";
// action types
export const PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE =
  "paginationCustomerCampaignReceiptMessage";
export const CREATE_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE =
  "createCustomerCampaignReceiptMessage";

// mutation types
export const SET_PAGINATION = "setPagination";
export const SET_IS_CLEAR_PAGINATION = "setIsClearPagination";
export const CLEAR_PAGINATION = "clearPagination";

export default {
  state: {
    path: "customer_campaign_receipt_message",
    isClearPagination: true,
    pagination: {
      page: 1,
      perPage: 25,
      orderBy: "created_at",
      isDesc: true,
      sortDirection: "asc",
      filter: ""
    }
  },
  getters: {},
  actions: {
    [PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE](context, payload) {
      ApiService.setHeader();
      return ApiService.getParams(`${context.state.path}/pagination`, {
        params: payload.params
      });
    },
    [CREATE_CUSTOMER_CAMPAIGN_RECEIPT_MESSAGE](context, payload) {
      ApiService.setHeader();
      return ApiService.post(`${context.state.path}`, payload);
    }
  },
  mutations: {
    [SET_PAGINATION](state, payload) {
      state.pagination = payload.pagination;
    },
    [SET_IS_CLEAR_PAGINATION](state, payload) {
      state.isClearPagination = payload.isClearPagination;
    },
    [CLEAR_PAGINATION](state) {
      state.pagination = {
        page: 1,
        perPage: 25,
        orderBy: "created_at",
        isDesc: true,
        sortDirection: "asc",
        filter: ""
      };
    }
  }
};